import React from 'react';
import { PhoneIcon } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'outline-red' | 'ghost' | 'dark';
  size?: 'sm' | 'md' | 'lg';
  href?: string;
  showPhoneIcon?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  href,
  className = '',
  showPhoneIcon = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-heading font-semibold uppercase tracking-wider transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-brand-red text-white hover:bg-brand-red-dark focus-visible:ring-brand-red',
    secondary: 'bg-white text-charcoal border-2 border-steel-200 hover:border-brand-red hover:text-brand-red focus-visible:ring-steel-500',
    outline: 'bg-transparent text-white border-2 border-white hover:bg-white hover:text-charcoal focus-visible:ring-white',
    'outline-red': 'bg-transparent text-white border-2 border-white hover:bg-white hover:text-brand-red focus-visible:ring-white',
    ghost: 'bg-transparent text-charcoal hover:bg-steel-50 focus-visible:ring-steel-500',
    dark: 'bg-charcoal text-white hover:bg-steel-900 focus-visible:ring-charcoal'
  };
  const sizes = {
    sm: 'text-sm px-4 py-2',
    md: 'text-base px-6 py-3',
    lg: 'text-lg px-8 py-4'
  };
  const combinedClassName = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;
  const content = <>
      {showPhoneIcon && <PhoneIcon className="w-4 h-4 mr-2" data-id="element-126" data-mp="17elh7z089i0k" />}
      {children}
    </>;
  if (href) {
    return <a href={href} className={combinedClassName} data-id="element-127" data-mp="1ldtgerwe4q4r">
        {content}
      </a>;
  }
  return <button className={combinedClassName} {...props} data-id="element-128" data-mp="1hcrh6b2h4e2s">
      {content}
    </button>;
}